import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { UserAPIResponseMapper } from '@/api/mapper/user';
import { getUsers } from '@/api/service/user';
import type { Member } from '@/types';

export const memberKeys = {
  all: ['members'] as const,
  list: () => [...memberKeys.all, 'list'] as const,
};

export function useMembersQuery(enabled = true) {
  return useQuery({
    queryKey: memberKeys.list(),
    queryFn: async (): Promise<Member[]> => {
      const users = await getUsers();
      return users.filter((user) => !user.is_superuser).map(UserAPIResponseMapper);
    },
    enabled,
  });
}

export function useInvalidateMembers() {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: memberKeys.list(),
      }),
    [queryClient]
  );
}
